export const PROTEIN_OPTIONS = [
  // ==== ANIMAL PROTEINS ====
  "Chicken Breast",
  "Chicken Thigh",
  "Turkey Breast",
  "Lean Turkey Breakfast Sausages",
  "Extra Lean Turkey Bacon",
  "93/7% Lean Ground Turkey/Beef",
  "Roast Beef",
  "Beef- Top Sirloin",
  "Beef- Top Round",
  "Beef- Bottom Round",
  "Beef- Flank Steak",
  "Beef- Ribeye",
  "Beef- New York Strip",
  "Pork Chop",
  "Pork Tenderloin",
  "Cod",
  "Tuna",
  "Atlantic Farm Raised Salmon",
  "Tilapia",
  "Grouper",
  "Crab Meat",
  "Sardines",

  // ==== DAIRY & EGGS ====
  "Whole Egg, Large",
  "Liquid Carton Egg Whites",
  "5% Fage Greek Yogurt",
  "2% Fage Fat Greek Yogurt",
  "Light & Fit Greek Yogurt",
  "Fage Fat Free Greek Yogurt",
  "4% Cottage Cheese",
  "2% Cottage Cheese",
  "Fat Free Cottage Cheese",
  "Whole Milk",
  "2% Milk",
  "Skim Milk",
  "Unsweetened Vanilla Almond Milk",

  // ==== PLANT PROTEINS ====
  "Tofu",
  "Edamame",
  "Black Beans",
  "Kidney Beans",
  "Pinto Beans",
  "Peanuts",
  "Lentils",
  "Chickpeas",

  // ==== OTHER ====
  "Deli Fresh Honey Ham",
  "Deli Fresh Oven Roasted Turkey Breast",
  "Protein powders",
  "Whey Isolate",
];

export const CARB_OPTIONS = [
  "White Rice",
  "Yellow Rice",
  "Quaker 1 min Oats",
  "Oat Bran",
  "Cream of Wheat",
  "Cream of Rice",
  "Quinoa cooked",
  "Sourdough Bread",
  "Ezekiel Bread",
  "English Muffin (plain)",
  "Bagel (plain)",
  "White Potato",
  "Red Potato",
  "Sweet Potato",
  "Yams",
  "White Pasta",
  "Lentils",
  "Chickpeas",
  "Black Beans",
  "Kidney Beans",
  "Pinto Beans",
  "Broccoli",
  "Asparagus",
  "Green Beans",
  "Zucchini",
  "Cauliflower",
  "Peas",
  "Carrots",
  "Beets",
  "Butternut Squash",
  "Mashed Pumpkin",
  "Spaghetti Squash",
  "Bananas",
  "Apples",
  "Strawberries",
  "Blueberries",
  "Blackberries",
  "Raspberries",
  "Honey",
];

export const FAT_OPTIONS = [
  "Extra Virgin Olive Oil",
  "Coconut Oil",
  "Butter",
  "Ghee",
  "Almonds",
  "Walnuts",
  "Cashews",
  "Pistachios",
  "Pecans",
  "Peanuts",
  "Brazil Nuts",
  "Macadamia Nuts",
  "Chia Seeds",
  "Flaxseed",
  "Green Olives",
  "Peanut Butter",
  "Almond Butter",
  "Cashew Butter",
  "Finely Shredded Mild Cheddar Cheese",
  "Shredded Swiss Cheese",
  "Provolone Sliced Cheese",
  "American Sliced Cheese",
  "Cream Cheese",
  "Reduced Fat Cream Cheese",
];
